import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SegmentoCamionList } from "./list"

type Entity = models.Segmento;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => Promise<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un Segmento
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}


/**
* Componente para editar un Entity
*/
export class SegmentoFormNoRx extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Sucursal = getField(selectores.Sucursal);
        const SegmentoCamiones = getField(SegmentoCamionList);
        const Number = getField(kea.Number);
        return (
            <div>
                <kea.Title titulo="Segmento" onRegresar={() => history.go("/catalogos/Segmento")} />
                {kea.autogrid(6, [
                    <Sucursal field="IdSucursalOrigen" label="Sucursal origen" />,
                    <Sucursal field="IdSucursalDestino" label="Sucursal destino" />,
                ])}

                {<SegmentoCamiones field="CostosSegmentoTipoCamion" idSegmento={value.IdRegistro} />}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const SegmentoForm = componentToRx(SegmentoFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/segmentos/edit/form.tsx